import { useSiteTime } from '@ge/shared/hooks/use-site-time';
import styled from 'styled-components';

const StyledTime = styled.span`
 display: flex;
  align-items: center;
  justify-content: end;
  margin: 5px 0 1px 10px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const LiveSiteClock = ({ siteTimezone }) => {
  const currentTime = useSiteTime(siteTimezone);
  return <StyledTime>{currentTime}</StyledTime>;
};